<script>
export default {
  components: {},
  data: vm => ({
    search: '',
    loading: false,
    invoiceData: [],
    selected: [],
    headers: [
      {
        text: vm.$t('page.invoices.view.date'),
        align: 'start',
        filterable: true,
        value: 'created',
        groupable: false,
        width: 200
      },
      {
        text: vm.$t('page.invoices.view.invoice.number'),
        align: 'start',
        filterable: true,
        value: 'invoiceId',
        groupable: false,
        width: 200
      },
      {
        text: vm.$t('page.invoices.view.amount'),
        align: 'start',
        filterable: true,
        value: 'amount',
        groupable: false,
        width: 200
      },
      {
        text: vm.$t('page.invoices.view.year'),
        value: 'year',
        align: 'center',
        width: 200
      }
    ]
  }),
  created: function() {

    this.getInvoices()
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] == 'invoiceId') {
          if (!isDesc[0]) {
            return a.invoiceId - b.invoiceId
          } else {
            return b.invoiceId - a.invoiceId
          }
        } else if (index[0] == 'created') {
          if (!isDesc[0]) {
            return new Date(a.created) - new Date(b.created)
          } else {
            return new Date(b.created) - new Date(a.created)
          }
        } else if (index[0] == 'year') {
          if (!isDesc[0]) {
            return new Date(a.year) - new Date(b.year)
          } else {
            return new Date(b.year) - new Date(a.year)
          }
        } else if (index[0] == 'amount') {
          if (!isDesc[0]) {
            return a.amount - b.amount
          } else {
            return b.amount - a.amount
          }
        } else if (index[0] == 'action') {
          if (!isDesc[0]) {
            return a.action.localeCompare(b.action)
          } else {
            return b.action.localeCompare(a.action)
          }
        }
      })
    },
    getInvoices() {
      this.$ordersService.getInvoices().then(response => {
        response.forEach(invoiceData => {
          this.invoiceData.push(invoiceData)
          invoiceData.year = new Date(invoiceData.created).getFullYear()
          invoiceData.created = new Date(
            invoiceData.created
          ).toLocaleDateString()
        })
      })
    },

    downloadInvoice: function() {
      let orderId = this.selected.map(e => e.orderId)
      this.$ordersService.getInvoice(orderId).then(response => {
        let a = document.createElement('a')
        a.href = 'data:application/pdf;base64,' + response
        a.download = this.$t('page.invoices.view.download.name') + orderId + '.pdf'
        a.click()
      })
    }
  }
}
</script>
<template>
  <div>
    <v-card flat tile color="transparent" class="pa-4">
      <v-card-title class="justify-center mb-5">
        <span class="headline text-center primary--text">
          {{ $t('page.invoices.view.invoice.header') }}
        </span>
      </v-card-title>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('page.invoices.view.search.label')"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="invoiceData"
        :search="search"
        :sort="customSort"
        :footer-props="{
          'items-per-page-text': 'Datensätze pro Seite',
          'items-per-page-all-text': 'Alle',
          'page-text': '{0}-{1} von {2}'
        }"
        class="elevation-1"
        show-select
        item-key="orderId"
        fixed-header
        single-select
        dense>
        <template #no-data>
          {{ $t('global.no.entries') }}
        </template>
        <template #[`item.created`]="{ item }">
          <v-card flat color="transparent">
            <v-card-subtitle name="created" class="pl-0 pr-0">
              <span class="secondary--text"> {{ item.created }}</span>
            </v-card-subtitle>
          </v-card>
        </template>
        <template #[`item.invoiceId`]="{ item }">
          <v-card flat color="transparent">
            <v-card-subtitle name="invoiceId" class="pl-0 pr-0">
              <span class="secondary--text"> {{ item.invoiceId }}</span>
            </v-card-subtitle>
          </v-card>
        </template>
        <template #[`item.amount`]="{ item }">
          <v-card flat color="transparent">
            <v-card-subtitle name="amount" class="pl-0 pr-0">
              <span class="secondary--text">
                <currency> {{ item.amount }} </currency>
              </span>
            </v-card-subtitle>
          </v-card>
        </template>
        <template #[`item.year`]="{ item }">
          <v-card flat color="transparent">
            <v-card-subtitle name="year" class="pl-0 pr-0">
              <span class="secondary--text"> {{ item.year }}</span>
            </v-card-subtitle>
          </v-card>
        </template>
      </v-data-table>
      <v-btn class="mt-4" color="primary" @click="downloadInvoice()">{{
          $t('page.invoices.view.download.invoice') }}</v-btn>
    </v-card>
  </div>
</template>
